
import { defineComponent } from 'vue';
import MessageWrap from '@/components/MessageWrap/index.vue';

export default defineComponent({
	name: 'typing-animation',

	components: {
		MessageWrap
	},

	props: {
		isShowMessageTail: {
			type: Boolean
		},

		avatar: {
			type: String
		}
	},

	emits: ['init'],

	mounted() {
		this.$emit('init');
	}
});
